import styled from 'styled-components';
import { makeColorDarker } from '../../utils/makeColorDarker';
import { Color } from '../../constants/constants';

export const HomeWrapper = styled.div`
    position: relative;
    height: 100%;
    background-color: #1f3a18;
    overflow-y: scroll;
`;

export const Overflow = styled.div`
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
  background-color: rgba(0, 0, 0, 0.4);
  transform: translateY(-100%);
  opacity: 0;
  z-index: 10;
  &.active {
    transform: translateY(0);
    opacity: 1;
  }
  &.light {
    background: transparent;
  }
  transition: transform 0.7s ease-in-out, opacity 0.4s ease-in-out 0.15s;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const Wrapper = styled.div`
  position: relative;
  background: linear-gradient(#141e30, #243b55);
  color: white;
  height: 100%;
  width: 100%;
  display: grid;
  grid-template-rows: 4fr 1fr;

  .buttons {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    .button {
      display: flex;
      gap: 10px;
    }
  }
`;

export const GameWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  gap: 50px 0;
  width: 100%;
  transform: perspective(1000px) translateZ(-300px) rotateX(30deg);
`;

export const BalanceStyled = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  gap: 5px;
  top: 20px;
  left: 20px;
  div::after {
    content: '$';
  }
  @media (max-width: 768px) {
    div {
      font-size: 2.5vmin;
    }
  }

  @media (max-width: 480px) {
    div {
      font-size: 3vmin;
    }
  }
`;

export const GameEndComponent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  height: 100%;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 4;
`;

export const OptionsPanel = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const CloseButton = styled.button`
  align-self: center;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  padding: 3.5px 6px;
  cursor: pointer;
  border: 0.23vmin solid ${Color.MainAccent};
  border-radius: 0.58vmin;
  color: ${Color.MainAccent};
  font-size: 1.4vmin;
  text-decoration: none;
  text-transform: uppercase;
  overflow: hidden;
  transition: 0.5s;
  &:hover {
    background: ${Color.MainAccent};
    color: #fff;
    box-shadow: 0 0 5px ${Color.MainAccent}, 0 0 25px ${Color.MainAccent},
      0 0 50px ${Color.MainAccent}, 0 0 100px ${Color.MainAccent};
  }
  &:disabled {
    pointer-events: none;
    border: 0.23vmin solid ${makeColorDarker(Color.MainAccent, 50)};
    color: ${makeColorDarker(Color.MainAccent, 50)};
    border-radius: 5px;
  }

  @media (max-width: 768px) {
    font-size: 1.4vmin;
    padding: 3.5px 6px;
    border: 0.35vmin solid ${Color.MainAccent};
  }

  @media (max-width: 480px) {
    font-size: 1.5vmin;
    padding:3px 6px;
  }
`;
